import { render, staticRenderFns } from "./UpsellRules-gt3.vue?vue&type=template&id=3194bf5a&scoped=true"
import script from "./UpsellRules-gt3.vue?vue&type=script&lang=js"
export * from "./UpsellRules-gt3.vue?vue&type=script&lang=js"
import style0 from "./UpsellRules-gt3.vue?vue&type=style&index=0&id=3194bf5a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3194bf5a",
  null
  
)

export default component.exports